import { compareAsc, format } from 'date-fns';
import allCountries from './../libs/countries.json';
import { countryOptions } from '../libs/enabled-countries';
import DOMPurify from 'dompurify';
import privacyURLs from './../libs/privacy-url.json';
import { el } from 'date-fns/locale';

export const updateObject = (obj, newProps) => {
  return {
    ...obj,
    ...newProps
  };
};

export const getUrlParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return "";
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const removeUrlParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {

    var prefix = encodeURIComponent(name) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

export const getStateDataByStateId = (stateId, countryCode) => {
  const allStates = objectArrayToObject(allCountries.list, "id", "states")[countryCode];

  if (allStates.length > 0) {
    const stateData = allStates.filter(state => state.id === stateId)[0];
    return stateData ? stateData : allStates[0];
  }
  else {
    return null;
  }
}

export const parseUrl = (urlStr, params) => {
  var tempDiv = document.createElement("div");
  tempDiv.innerHTML = urlStr;
  urlStr = tempDiv.firstChild.nodeValue;
  // split into path & query string
  var parts = urlStr.split("?");
  if (parts.length > 1) {
    // transfer paramters to params array
    var nvpairs = parts[1].split("&");
    for (var i = 0; i < nvpairs.length; i++) {
      var nvpair = nvpairs[i].split("=");
      if (nvpair.length > 1) {
        params[nvpair[0]] = nvpair[1];
      }
    }
  }
  // return path component
  return parts[0];
};

export const handleInputChange = (e, fields, fieldId) => {
  const updatedFields = {
    ...fields
  };
  const updatedField = {
    ...updatedFields[fieldId]
  };
  if (updatedField.type === "checkbox" || updatedField.type === "radio") {
    updatedField.selected = e.target.checked;
    updatedField.value = e.target.checked;
  }
  else {
    updatedField.value = e.target.value;
  }
  if (updatedField.validation.required) {
    updatedField.valid = validateInput(
      updatedField.value,
      updatedField.validation
    );
  }
  if (updatedField.validation.checked) {
    updatedField.valid = e.target.checked;
  }
  updatedField.touched = true;
  updatedFields[fieldId] = updatedField;

  let formIsValid = true;
  for (let fieldId in updatedFields) {
    formIsValid = updatedFields[fieldId].valid && formIsValid;
  }

  return {
    fields: updatedFields,
    formIsValid: formIsValid
  }
}

export const validateInput = (value, rules) => {
  let isValid = true;

  if (!rules) return true;
  if (rules && !rules.required && !value) return true;
  if (rules && rules.required && !value) return false;

  if (rules.min !== undefined) {
    isValid = value && parseInt(value) >= rules.min && isValid;
  }

  if (rules.max !== undefined) {
    isValid = (value ? parseInt(value) <= rules.max : false) && isValid;
  }

  if (rules.minLength) {
    isValid = value && value.toString().trim().length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value && value.toString().trim().length <= rules.maxLength && isValid;
  }

  if (rules.length) {
    isValid = value && value.toString().trim().length === rules.length && isValid;
  }

  if (rules.required) {
    if (typeof value === "string" || typeof value === "number") {
      isValid = (value.toString().trim() !== "" && value !== "NO_VALUE") && isValid;
    }
    else {
      if (rules.type === "list") {
        isValid = value.length > 0;
      }
      else {
        isValid = value && isValid;
      }
    }
  }

  if (rules.type === "number") {
    const p = /^[\+\-]?\d*\.?\d+(?:[Ee][\+\-]?\d+)?$/;
    isValid = value ? (p.test(value) && isValid) : isValid;
  }

  if (rules.type === "alphanumeric") {
    const p = /^[a-z0-9]*$/i;
    isValid = p.test(value) && isValid;
  }

  if (rules.type === "prefix" && rules.prefixLength && rules.startswith) {
    const startsWith = rules.startswith;
    let validPrefix = false;
    if (startsWith.constructor === Array) {
      if (startsWith.length > 0) {
        for (let i = 0; i < startsWith.length; i++) {
          if (value.substring(0, rules.prefixLength) === startsWith[i]) {
            validPrefix = true;
            break;
          }
        }
      }
      else {
        validPrefix = true;
      }
    }
    else {
      validPrefix = value.substring(0, rules.prefixLength) === startsWith;
    }

    isValid = validPrefix && isValid;
  }

  if (rules.type === "email") {
    const p = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let values = [value];

    if (rules.acceptMultiple) {
      if (value.indexOf(rules.separator) > -1) {
        values = value.split(rules.separator);
      }
    }

    for (let i = 0; i < values.length; i++) {
      if (values[i]) {
        isValid = p.test(values[i].trim()) && isValid;
      }
    }

  }

  if (rules.customRegex && value) {
    const regex = new RegExp(rules.customRegex);
    isValid = regex.test(value) && isValid;
  }

  if (rules.type === "file" && typeof value === "object" && rules.maxSize) {
    isValid = value.size <= rules.maxSize && isValid;
  }

  if (rules.type === "file" && typeof value === "object" && rules.acceptedFileTypes) {
    isValid = rules.acceptedFileTypes.includes(value.name.substr(value.name.lastIndexOf(".") + 1)) && isValid;
  }

  if (rules.type === "list" && typeof value === "object") {

  }

  return isValid;
};

export const getIndex = (data, property, value) => {
  for (var i = 0, l = data.length; i < l; i++) {
    if (data[i][property] === value) {
      return i;
    }
  }
  return -1;
}

export const escapeHtml = text => {
  let modifiedText = text;

  if (modifiedText && typeof modifiedText === "string") {
    modifiedText = modifiedText.replace(/\\\//g, "/");
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    };
    modifiedText = modifiedText.replace(/[&<>"']/g, function (m) { return map[m]; });
  }

  return modifiedText;
}

export const createFormAndSubmit = (method, formTarget, actionURL, fieldsData) => {
  const defaultMethod = (new RegExp(/\?.+=.*/g)).test(actionURL) ? "POST" : "GET";
  const formMethod = method || defaultMethod;

  if (actionURL) {
    let formHTMLString = "<form id='tempForm' ";
    formHTMLString += "method='" + formMethod + "' ";
    formHTMLString += "action='" + DOMPurify.sanitize(actionURL) + "' ";
    formHTMLString += "target='" + formTarget + "' ";
    formHTMLString += "enctype='application/x-www-form-urlencoded' ";
    formHTMLString += ">";

    if (fieldsData) {
      for (var field in fieldsData) {
        let inputHTMLString = "<input type='hidden' ";
        inputHTMLString += "name='" + field + "' ";
        inputHTMLString += "value='" + fieldsData[field] + "' ";
        inputHTMLString += " />";

        formHTMLString += inputHTMLString;
      }
    }

    formHTMLString += "</form>";

    document.getElementsByTagName("div")[0].insertAdjacentHTML('beforeend', formHTMLString);
    document.getElementById("tempForm").submit();
    document.getElementById("tempForm").remove();
  }
}

export const serialize = obj => {
  let str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(p + "=" + obj[p]);
    }
  }
  return str.join("&");
}

export const isObject = val => {
  return Object.prototype.toString.call(val) === '[object Object]';
}

export const colorShade = (col, amt) => {

  var usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00FF) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000FF) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);

}

export const sortObj = (property, order) => {
  return function (a, b) {
    if (a[property] < b[property]) {
      return -1 * order;
    }
    if (a[property] > b[property]) {
      return 1 * order;
    }
    return 0;
  }
}

export const arrayFromObj = obj => {
  const fields = [];
  for (let key in obj) {
    fields.push({ id: key, value: obj[key] });
  }
  return fields;
}

export const getPaginationData = (totalRecords, rowsPerPage, maxPageLinks, currentPage) => {
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  if (currentPage < 0) currentPage = 1;
  if (currentPage > totalPages) currentPage = totalPages;

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage - 1, totalRecords - 1);

  let maxLeft = (currentPage - Math.floor(maxPageLinks / 2)); // 14
  let maxRight = (currentPage + Math.floor(maxPageLinks / 2)); // 18

  if (maxLeft < 1) {
    maxLeft = 1
    maxRight = maxPageLinks;
  }

  if (maxRight > totalPages) {
    maxLeft = totalPages - (maxPageLinks - 1);

    if (maxLeft < 1) {
      maxLeft = 1;
    }
    maxRight = totalPages;
  }

  let pages = [];
  for (let i = maxLeft; i <= maxRight; i++) pages.push(i);

  return {
    totalRecords: totalRecords,
    totalPages: totalPages,
    pages: pages,
    currentPage: currentPage,
    startIndex: startIndex,
    endIndex: endIndex
  }
}

export const getUpdatedPageNumbers = (rows, rowsPerPage, page, maxPageLinks) => {
  const totalPages = Math.ceil(rows / rowsPerPage);

  let maxLeft = (page - Math.floor(maxPageLinks / 2)); // 14
  let maxRight = (page + Math.floor(maxPageLinks / 2)); // 18

  if (maxLeft < 1) {
    maxLeft = 1
    maxRight = maxPageLinks;
  }

  if (maxRight > totalPages) {
    maxLeft = totalPages - (maxPageLinks - 1);

    if (maxLeft < 1) {
      maxLeft = 1;
    }
    maxRight = totalPages;
  }

  let pages = [];
  for (let i = maxLeft; i <= maxRight; i++) pages.push(i);
  return pages;
}

export function removeByAttr(arr, attr, value) {
  var i = arr.length;
  while (i--) {
    if (arr[i]
      && arr[i].hasOwnProperty(attr)
      && (arguments.length > 2 && arr[i][attr] === value)) {

      arr.splice(i, 1);

    }
  }
  return arr;
}

export const objectArrayToObject = (objectArray, id, value) => {
  const transformedObject = {};
  objectArray.length > 0 && objectArray.forEach(obj => { transformedObject[obj[id]] = value ? (obj[value] ? obj[value] : 0) : obj });
  return transformedObject;
}

export const ObjectToArray = (obj) => {
  const arrayOfObject = [];
  Object.keys(obj).forEach(key => arrayOfObject.push(obj[key]));
  return arrayOfObject;
}

export const getSetterName = (variableName) => {
  let result = "set";
  if (variableName.length > 0) {
    result += variableName.charAt(0).toUpperCase() + variableName.substr(1, variableName.length)
  }
  return result;
}

export const objectToObjectArray = (obj, identifierKey, valueKey) => {
  let result = [];
  for (let property in obj) {
    result.push({
      [identifierKey]: property,
      [valueKey]: obj[property]
    })
  }

  return result;
}

export const createFlatArray = (start, end) => {
  let result = [];
  for (let i = start; i <= new Array(end).length; i++) {
    result.push(i);
  }
  return result;
}

export const emptyObject = obj => {
  Object.keys(obj).forEach(function (key) { delete obj[key]; });
  return obj;
}
export const handleSurveyLinkData = (data, eventHandler) => {
  if (data) {
    let surveyBasicInfo = {}
    try {
      surveyBasicInfo = JSON.parse(atob(data));
    } catch (e) {
      //broken link, data manupulated or not correct
      eventHandler({ type: "link-error" });
    }
    // surveyBasicInf = {"surveyId": "asd76a5sd75a6s7a57s6dasd65a76s","emailId": "user@hpdomain.com","expiryDate": "2020-07-07T19:14:36.835+0530"}
    if (surveyBasicInfo.surveyId && surveyBasicInfo.emailId && surveyBasicInfo.expiryDate) {
      if (compareAsc(new Date(surveyBasicInfo.expiryDate), new Date()) === 1)
        eventHandler({ type: "success", data: surveyBasicInfo });//dispatch getSurveyDetails
      else eventHandler({ type: "expired" });//survey expired
    }
    else eventHandler({ type: "link-error" }); //data not correct  
  }
  else eventHandler({ type: "link-error" }); // user tried to directly access this page, or link broken
}

//proper format data
//data?, and valida data
export const validateSurveyData = () => {
  console.log(validateSurveyData)
  let data = getUrlParameterByName("data");
  if (data) {
    let surveyBasicInfo = {}
    try {
      surveyBasicInfo = JSON.parse(atob(data));
      console.log(surveyBasicInfo)
    } catch (e) {
      console.log(e)
      //broken link, data manupulated or not correct
      return false;
    }
    // surveyBasicInf = {"surveyId": "asd76a5sd75a6s7a57s6dasd65a76s","emailId": "user@hpdomain.com","expiryDate": "2020-07-07T19:14:36.835+0530"}
    if (surveyBasicInfo.surveyId && surveyBasicInfo.emailId && surveyBasicInfo.expiryDate) return true;
    else return false;
  }
  else return false;

}

export const decodeRequestIsFor = () => {
  let requestIsFor = "";
  const data = getUrlParameterByName("data");
  if (data) {
    let decodedData = null;
    try {
      decodedData = JSON.parse(atob(data));
      if (decodedData.surveyId && decodedData.emailId && decodedData.expiryDate) {
        requestIsFor = "SURVEY";
      }
      else if (decodedData.teamId) {
        requestIsFor = "UAM_TEAM_INVITE";
      }
      else if (decodedData.priceListUploadId) {
        requestIsFor = "PRICE_LIST_APPROVAL";
      }
      else {
        requestIsFor = "OTHER";
      }
    }
    catch (e) {
      // do nothing
    }
  }
  return requestIsFor;
}

export const decodePriceListDetails = () => {
  const data = getUrlParameterByName("data");
  if (data) {
    let decodedData = null;
    try {
      decodedData = JSON.parse(atob(data));
      localStorage.setItem("priceListName", decodedData.priceListName || "");
      localStorage.setItem("vendorName", decodedData.vendorName || "");
      localStorage.setItem("rateCardType", decodedData.rateCardType || "");
    }
    catch (e) {
      console.log("Decoding of price list details", e);
    }
  }
}


export const applyParamsToURL = (paramData, isUrlToBeChanged) => {
  //shivam-write doc
  let appendableParams = "?";
  let newUrl = "";
  if (paramData.length > 0) {
    paramData.forEach((param, i) => {
      appendableParams += (i !== 0 ? "&" : "") + (param.paramName + "=" + param.paramValue);
    });
    newUrl = window.location.href.split('?')[0] + appendableParams;
    if (isUrlToBeChanged) window.location.href = newUrl;
    return newUrl;
  }
}

export const getIndexByPropertyName = (arr, name, value) => {
  return arr.map(arrItem => arrItem[name]).indexOf(value);
}

export const checkDistinctObjectsInArray = (arr, key) => {
  let distinct = false;
  let currentValue = "";
  for (let i = 0; i < arr.length; i++) {
    if (currentValue && currentValue !== arr[i][key]) {
      distinct = true;
      break;
    }
    else {
      currentValue = arr[i][key];
    }
  }

  return distinct;
}

export const capitalizeText = string => {
  if (string) {
    const smallCapsString = string.toLowerCase();
    const firstLetter = smallCapsString.substring(0, 1);
    return firstLetter.toUpperCase() + smallCapsString.substring(1);
  }

  return "";
}

export const isValidDate = date => {
  return date instanceof Date && !isNaN(date);
}


//return list of enabled regions
export const getAllRegions = () => countryOptions.map(({ id, label }) => ({ id, label }));

//return list of enabled countries
export const getAllEnabledCountries = () => {
  let countries = [];
  countryOptions.forEach(region => {
    region.subOptions.forEach(country => {
      if (country.id && !countries.includes(country.id)) countries.push(country.id);
    });
  });

  return countries;
};

//return list of regions(id and label) only for regionCodes Passed
export const getRegions = (regionCodes) => countryOptions.map(({ id, label }) => ({ id, label })).filter(({ id }) => regionCodes.indexOf(id) != -1);

//returns region code acording to country code from enables-countries list and null if country code not found
export const getRegionByCountryCode = countryCode => {
  for (let regionData of countryOptions)
    for (let country of regionData.subOptions)
      //if (country.id.split('_')[1] === countryCode)
      if (country.id === countryCode)
        return regionData.id;
  return null;
}

//works as below
//regionCode(valid) => list of countries from regionCode passed
//regionCode(Invalid) => [], empty array if regionCode is Invalid
//regionCode(null) => all countries
export const getCountriesByRegionCode = (regionCode, keepLanguageInfo) => {
  let filteredRegion = countryOptions || [];
  //if regionCode is null we'll not filter regions, i.e include all countries
  if (!!regionCode) filteredRegion = filteredRegion.filter(({ id }) => id === regionCode);
  let countries = [];
  let uniqueCountryIds = new Set();
  //collecting all countries , either for single region or multiple and removing local description from labels
  for (let region of filteredRegion) {
    countries = [
      ...countries, ...region.subOptions.map(
        ({ id, label, languageLabel }) =>
        (
          {
            id: keepLanguageInfo ? id : id.split('_')[1],
            label: label + (languageLabel && keepLanguageInfo ? " (" + languageLabel + ")" : "")
          }
        )
      )
    ];
  }
  //ignoring duplicate countries with multiple locales
  countries = countries.filter(({ id }) => {
    if (uniqueCountryIds.has(id)) { return false; }
    uniqueCountryIds.add(id);
    return true;
  });
  return countries;
}

export function getCountryNameByCountryCode(countryCode, langCode) {
  let countryName = "";
  if (countryCode === "WW") {
    countryName = "Worldwide"
  }

  if (countryCode && !langCode && countryCode.includes("_")) {
    if (countryCode.split("_").length === 2) {
      langCode = countryCode.split("_")[0];
      countryCode = countryCode.split("_")[1];
    }
    else {
      countryName = countryCode;
    }
  }

  if (countryCode) {
    for (let i = 0; i < allCountries.list.length; i++) {
      const currentCountry = allCountries.list[i];
      if (currentCountry.id === countryCode) {
        if (langCode && currentCountry.multiLocale && currentCountry.multiLocale.length) {
          const locales = currentCountry.multiLocale.filter(locale => locale.id === countryCode && locale.lang === langCode);
          if (locales.length && locales[0].label) {
            countryName = locales[0].label;
          }
        }
        countryName = countryName || currentCountry.label;
        break;
      }
    }
  }

  return countryName;
}

export const getCountriesByRegions = (regions) => {
  const countries = []
  regions.map(region => {
    countryOptions.map(regionCode => {
      if (regionCode.id === region) {
        regionCode.subOptions.map(country => {
          countries.push(country.id)
        })
      }
    })
  })

  return countries;
}

export const getHPWebsiteURL = (countryCode, languageCode) => {
  let country = countryCode ? countryCode.toLowerCase() : "us";
  let region = getRegionByCountryCode(countryCode.toUpperCase());
  let lang = languageCode ? languageCode.toLowerCase() : "en";
  let endPointURL = "/hp-information/environment/product-recycling.html";

  if (country === "ca") {
    country = "us";
    lang = "en";
  };

  if (country === "gb") country = "uk";
  if (country === "id") lang = "en";
  if (country === "mo") country = "cn";
  if (region === "APJ") endPointURL = "/hp-information/recycling/ink-toner.html";

  const LARCountriesCommonURL = {
    ar: "argentina",
    cr: "costa_rica",
    ec: "ecuador",
    pa: "panama",
    pe: "peru",
    pr: "puerto-rico",
    cl: "chile",
    co: "colombia"
  }

  if (LARCountriesCommonURL[country]) {
    return "https://www8.hp.com/mx/es/hp-information/sustainable-impact/planet-product-recycling.html#filters_product_recycling=country-" + LARCountriesCommonURL[country];
  }

  return "https://www8.hp.com/" + country + "/" + lang + endPointURL;
}

export const getHPPrivacyStatementURL = (countryCode, languageCode) => {
  let country = countryCode ? countryCode.toLowerCase() : "us";
  let lang = languageCode ? languageCode.toLowerCase() : "en";

  const commonEMEAAfricaCountries = ["ma", "mt", "mo", "mc"];
  const commonEMEAMiddleEastCountries = ["sa", "ae", "bh", "qa", "cy", "kw", "om"];
  const commonLatinCountries = ["cr", "pa"];
  const forceApplyEnglishToCountries = ["id", "th"];

  if (country === "gb") country = "uk";
  if (country === "lu") country = "fr";
  if (country === "li") country = "de";
  if (country === "il") lang = "he";
  if (country === "mo") { lang = "zh"; country = "hk"; }

  if (forceApplyEnglishToCountries.includes(country)) lang = "en";
  if (commonLatinCountries.includes(country)) country = "lamerica_nsc_cnt_amer";
  if (commonEMEAAfricaCountries.includes(country)) country = "emea_africa";
  if (commonEMEAMiddleEastCountries.includes(country)) country = "emea_middle_east";

  return privacyURLs[`${country}-${lang}`] || "https://www8.hp.com/" + country + "/" + lang + "/privacy/privacy-central.html";
}

export const getHPMarketingURL = (countryCode, languageCode) => {
  const multiLocaleCountries = ["be", "ch"];
  let country = countryCode ? countryCode.toLowerCase() : "us";
  let lang = multiLocaleCountries.indexOf(country) !== -1 ? languageCode.toLowerCase() : "";
  let marketingURL = "http://www.hp.com/";
  const commonEMEAMiddleEastCountries = ["sa", "ae", "bh", "qa", "cy", "kw", "om"];

  if (country === "gb") country = "uk";
  if (country === "mt") country = "uk";
  if (country === "mc") country = "fr";
  if (country === "li") country = "de";

  if (commonEMEAMiddleEastCountries.includes(country)) {
    country = "me2";
    lang = "uae";
  }

  marketingURL += country + "/";
  if (lang) {
    marketingURL += lang + "/";
  }
  marketingURL += country === "it" ? "riciclohp" : "hprecycle";

  return marketingURL;
}

export const getLastNumberOfYears = (fromYear = 2020, totalYears = 3) => {
  const lastNumberOfYears = [];
  const currentDate = new Date();
  for (let i = 0; i < totalYears; i++) {
    const year = currentDate.getFullYear() - i;
    if (parseInt(year) >= fromYear) {
      lastNumberOfYears.push(year);
    }
  }

  return lastNumberOfYears;
}

export const sumOfProperty = (arr, prop) => {
  let total = 0
  for (let i = 0; i < arr.length; i++) {
    total += parseInt(arr[i][prop]);
  }
  return total
}

export const convertFileToBase64 = async (file) =>
  new Promise((resolve, reject) => {
    if (file) {
      if (file.contentHostedExternally) {
        resolve({ externallyHostedData: { ...file } })
      }
      else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (e) => reject(e);
      }
    }
    else {
      resolve(null);
    }
  });

export const processMultipleFiles = async (files) => {
  const filesToProcess = files.filter(file => Boolean(file.data));
  const promise = new Promise((resolve, reject) => {
    if (filesToProcess.length) {
      Promise.all(filesToProcess.map(file => convertFileToBase64(file.data))).then((values) => {
        const base64Data = filesToProcess.map((f, i) => ({
          id: f.id,
          base64String: values[i],
          name: filesToProcess[i].data.name,
          type: filesToProcess[i].data.type
        }));
        resolve(base64Data);
      }).catch(error => {
        reject(null);
      });
    }
    else {
      resolve(null);
    }
  });

  return promise;
}

export const cleanObject = (object, valuesToExclude) => {
  let cleanedObject = {};
  Object.keys(object).forEach(objKey => {
    if (!valuesToExclude.includes(object[objKey])) {
      cleanedObject[objKey] = object[objKey];
    }
  })
  return cleanedObject;
}

export const scanForProperty = (obj, prop) => {
  if (!obj) return null;

  for (let key in obj) {
    if (key === prop) {
      return obj[key];
    }

    if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
      return scanForProperty(obj[key], prop);
    }
  }

  return null;
}

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const generateCompanyOptionsFromAmplifyData = data => {
  let companyOptions = [];
  data.forEach(companyData => {
    companyOptions.push({
      id: [companyData.partnerId, companyData.locationId, companyData.companyName].join('|||---|||'),
      label: companyData.companyName
    })
  })
  return companyOptions;
}

export const getSubArray = (array, startIndex, length) => array.slice(startIndex, startIndex + length);

export const handleCountryChange = (id, option) => {
  const urlObject = window.location;
  const urlParamId = getUrlParameterByName("id", urlObject.href.split("#")[0]);
  const languageCode = getUrlParameterByName("languageCode", urlObject.href.split("#")[0]) || "en";
  let newUrl = urlObject.origin + urlObject.pathname;

  if (window.location.hash) {
    const urlHasSlashAtEnd = newUrl.slice(newUrl.length - 1) === "/";
    let hashValue = window.location.hash.substring(1);
    if (hashValue.slice(0, 1) === "/") {
      hashValue = hashValue.substring(1);
    }
    newUrl += "#" + (urlHasSlashAtEnd ? hashValue : "/" + hashValue);
  }

  window.dataLayer.push({ event: 'e_linkClick', linkPlacement: 'countrySelectorMenu', linkID: 'countryChange' });
  createFormAndSubmit("GET", "_self", newUrl, {
    ...(urlParamId) && { id: urlParamId },
    countryCode: option.id,
    languageCode: languageCode
  });
}

export const getTranslator = (translatingFunc) => (id, defaultMessage) => translatingFunc({ id, defaultMessage: defaultMessage || " " });


export function getCurrencySymbol(currencyCode) {
  if (currencyCode === "USD") {
    return "$"; //US dollar
  }

  else if (currencyCode === "EUR") {
    return "€"; //EURO
  }

  else if (currencyCode === "CHF") {
    return "SFr."; //France
  }

  else if (currencyCode === "HKD") {
    return "HK$"; //HK
  }

  else if (currencyCode === "IDR") {
    return "Rp"; //HK
  }

  else if (currencyCode === "AUD") {
    return "A$"; //Australia
  }

  else if (currencyCode === "SGD") {
    return "S$"; //Singapore
  }

  else if (currencyCode === "MYR") {
    return "RM"; //Malaysia
  }

  else if (currencyCode === "KRW") {
    return "₩"; //Korea
  }

  else if (currencyCode === "SEK") {
    return "Kr"; //Sweden
  }

  else if (currencyCode === "GBP") {
    return "£"; //England
  }

  else if (currencyCode === "CNY" || currencyCode === "RMB" || currencyCode === "JPY") {
    return "¥"; //RMB
  }

  else if (currencyCode === "CAD") {
    return "C$"; //CAD
  }

  else if (currencyCode === "ZAR") {
    return "R"; //South Africa
  }

  else if (currencyCode === "NZD") {
    return "NZ$"; //South Africa
  }

  else if (currencyCode === "PHP") {
    return "₱"; //Phillipines
  }

  else if (currencyCode === "THB") {
    return "฿"; //Thailand
  }

  else if (currencyCode === "TWD") {
    return "NT$"; //Taiwan
  }

  else if (currencyCode === "VND") {
    return "₫"; //Vietnam
  }

  else if (currencyCode === "XXX") {
    return "#"; //DEFAULT
  }

  else {
    return currencyCode;
  }
}

export const validCountryCodes = countriesString => {
  // countriesString is a string of comma separated country codes
  let validCountries = [];
  const selectedCountryList = countriesString.split(",").filter(s => s);
  const allEnabledCountries = getAllEnabledCountries();

  for (let i = 0; i < selectedCountryList.length; i++) {
    if (allEnabledCountries.includes(selectedCountryList[i])) {
      validCountries.push(selectedCountryList[i])
    }
  }

  return validCountries;
}

export const isValidCountry = countryCode => {
  const allEnabledCountries = getAllEnabledCountries();
  return allEnabledCountries.includes(countryCode);
}

export const detectGeographicalScopeFromCountries = countriesString => {
  // countriesString is a string of comma separated country codes

  const selectedCountryList = countriesString.split(",").filter(s => s);
  if (selectedCountryList.length === 1) return "Country";

  let regions = [];
  selectedCountryList.forEach(country => {
    const regionCode = getRegionByCountryCode(country);
    if (regionCode && !regions.includes(regionCode)) {
      regions.push(regionCode);
    }
  });

  if (regions.length === 1) return "Regional";

  return "WW";
}

export const detectRegionFromCountries = countriesString => {
  // countriesString is a string of comma separated country codes

  const selectedCountryList = countriesString.split(",").filter(s => s);
  let regions = [];
  selectedCountryList.forEach(country => {
    const regionCode = getRegionByCountryCode(country);
    if (regionCode && !regions.includes(regionCode)) {
      regions.push(regionCode);
    }
  });

  if (regions.length === 1) return regions[0];

  return "WW";
}

export const generateQuoteNumber = countriesString => {
  // countriesString is a string of comma separated country codes
  const geographicalScope = detectGeographicalScopeFromCountries(countriesString);
  const currentDate = format(new Date(), 'yyMMdd');
  const randomFourDigits = Math.floor(1000 + Math.random() * 9000);

  return `${geographicalScope}-${currentDate}-${randomFourDigits}`;
}

export const isValidRequestData = (requestData, optionalProps) => {
  for (let prop in requestData) {
    const currentProp = requestData[prop];

    if (!optionalProps.includes(prop)) {
      if (typeof currentProp === "object") {
        if (currentProp === null) return false;
        if (Array.isArray(currentProp) && !currentProp.length) {
          return false;
        }
        else {
          if (!Object.keys(currentProp).length) return false;
        }
      }
      if (typeof currentProp === "undefined") return false;
      if (typeof currentProp === "string" && currentProp.trim() === "") return false;
      if (typeof currentProp === "number" && (currentProp + "").trim() === "") return false;
    }
  }
  return true;
}

export const formatBigNumber = (num, digitsAfterDecimal = 1) => {
  if (!num) return 0;

  const symbols = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const pattern = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = symbols.slice().reverse().find(function (item) {
    return num >= item.value;
  });

  return item ? (num / item.value).toFixed(digitsAfterDecimal).replace(pattern, "$1") + item.symbol : num;
}

export const formatNumberAsCurrency = num => {
  if (typeof num !== "number") return num;

  return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export const getStatusDescriptionFromStatusValue = status => {
  if (status === "PENDING") {
    return status = "Pending";
  }
  else if (status === "PAID") {
    return status = "Paid";
  }
  else if (status === "PROVIDED") {
    return status = "Provided";
  }
  else if (status === "PENDING_HP_REVIEW") {
    return status = "Pending HP Review";
  }
  else if (status === "ARRANGED") {
    return status = "Arranged";
  }
  else if (status === "REJECTED") {
    return status = "Rejected";
  }
  else if (status === "REQUESTED") {
    return status = "Requested";
  }
  else if (status === "ACCEPTED") {
    return status = "Accepted";
  }
  else if (status === "APPROVED") {
    return status = "Approved";
  }
  else if (status === "PENDING_PRICES") {
    return status = "Pending Prices";
  }
  else if (status === "HP_REVIEW_PEDNING") {
    return status = "HP Review Pending";
  }
  else if (status === "CONFIRMATION_PENDING") {
    return status = "Confirmation Pending";
  }
  else if (status === "DRAFT") {
    return status = "Draft";
  }
  else if (status === "CREATED") {
    return status = "Created";
  }
  else if (status === "LOST") {
    return status = "Lost";
  }
  else if (status === "ORDER_SUBMITTED") {
    return status = "Order Submitted";
  }
  else if (status === "ORDER_RECEIVED") {
    return status = "Order Received";
  }
  else if (status === "ORDER_SENT") {
    return status = "Order Sent";
  }
  else if (status === "ORDER_CANCELLED") {
    return status = "Order Cancelled";
  }
  else if (status === "ASSETS_RECEIVED") {
    return status = "Assets Received";
  }
  else if (status === "ASSETS_COLLECTED") {
    return status = "Assets Collected";
  }
  else if (status === "PAYMENT_PENDING") {
    return status = "Payment Pending";
  }
  else if (status === "AVAILABLE") {
    return status = "Available";
  }
  else if (status === "NOT_AVAILABLE") {
    return status = "Not Available";
  }
  else if (status === "ACTIVE") {
    return status = "Active";
  }
  else if (status === "COMPLETED") {
    return status = "Completed";
  }
  else if (status === "ORDER_COMPLETED") {
    return status = "Order Completed";
  }
  else if (status === "VENDOR_PRICES_PROVIDED") {
    return status = "Vendor Prices Provided ";
  }
  else if (status === "VENDOR_PRICES_PENDING") {
    return status = "Vendor Prices Pending";
  }
  else if (status === "SERVICE_PAYMENT_TO_HP_PENDING") {
    return status = "Service Payment To HP Pending"
  }
  else if (status === "SERVICE_PAYMENT_TO_HP_PARTNER_PENDING") {
    return status = "Service Payment To HP Partner Pending"
  }
  else if (status === "SERVICE_PAYMENT_TO_DRV_PENDING") {
    return status = "Service Payment To DRV Pending"
  }
  else if (status === "SERVICE_PAYMENT_TO_CUSTOMER_PENDING") {
    return status = "Service Payment To Customer Pending"
  }
  else if (status === "SERVICE_PAYMENT_TO_PARTNER_TRIGGERED") {
    return status = "Service Payment To Partner Triggered"
  }
  else if (status === "HARDWARE_PAYMENT_TO_CUSTOMER_PENDING") {
    return status = "Hardware Payment To Customer Pending"
  }
  else if (status === "HARDWARE_PAYMENT_TO_CUSTOMER_ARRANGED") {
    return status = " Hardware Payment To Customer Arranged"
  }
  else if (status === "PAYMENT_TO_CUSTOMER_PENDING") {
    return status = "Payment to Customer Pending"
  }
  else if (status === "PAYMENT_TO_HP_PARTNER_PENDING") {
    return status = "Payment to HP Partner Pending"
  }
  else if (status === "HARDWARE_PAYMENT_TO_HP_PENDING") {
    return status = "Hardware Payment To HP Pending"
  }
  else if (status === "HARDWARE_PAYMENT_TO_HP_ARRANGED") {
    return status = "Hardware Payment To HP Arranged"
  }
  else if (status === "HARDWARE_PAYMENT_TO_HP_COMPLETED") {
    return status = "Hardware Payment To HP Completed"
  }
  else if (status === "HARDWARE_PAYMENT_TO_PARTNER_PENDING") {
    return status = "Hardware Payment To Partner Pending"
  }
  else if (status === "HARDWARE_PAYMENT_TO_PARTNER_ARRANGED") {
    return status = "Hardware Payment To Partner Arranged"
  }
  else if (status === "HARDWARE_PAYMENT_TO_PARTNER_COMPLETED") {
    return status = "Hardware Payment To Partner Completed"
  }
  else if (status === "PAYMENT_TO_HP_PENDING") {
    return status = "Payment To HP Pending"
  }
  else if (status === "PAYMENT_TO_HP_TRIGGERED") {
    return status = "Payment To HP Triggered"
  }
  else if (status === "PAYMENT_TO_HP_COMPLETED") {
    return status = "Payment To HP Completed"
  }
  else if (status === "PAYMENT_TO_PARTNER_COMPLETED") {
    return status = "Payment To Partner Completed"
  }
  else if (status === "PAYMENT_TO_HP_PARTNER_COMPLETED") {
    return status = "Payment To HP Partner Completed"
  }
  else if (status === "ON_HOLD") {
    return status = "On Hold"
  }
  else if (status === "SERVICE_PAYMENT_TO_HP_ARRANGED") {
    return status = "Service Payment To HP Arranged"
  }
  else if (status === "PAYMENT_TO_CUSTOMER_ARRANGED") {
    return status = "Payment To Customer Arranged"
  }
  else if (status === "PAYMENT_TO_HP_ARRANGED") {
    return status = "Payment To HP Arranged"
  }
  else if (status === "EXPIRED") {
    return status = "Expired"
  }
  else if (status === "SERVICE_PAYMENT_TO_PARTNER_PENDING") {
    return status = "Service Payment To Partner Pending"
  }
  else if (status === "SERVICE_PAYMENT_TO_PARTNER_ARRANGED") {
    return status = "Service Payment To Partner Arranged"
  }
  else if (status === "SERVICE_PAYMENT_TO_PARTNER_COMPLETED") {
    return status = "Service Payment To Partner Completed"
  }
  else if (status === "HARWARE_PAYMENT_TO_HP_COMPLETED") {
    return status = "Hardware Payment To HP Completed"
  }
  else if (status === "VENDOR_PRICES_REFUSED") {
    return status = "Vendor Prices Refused"
  }
  else if (status === "NO_RESIDUAL_VALUES") {
    return status = "No Residual Values"
  }
  else if (status === "LOGISTICS_TOO_EXPENSIVE") {
    return status = "Logistics Too Expensive"
  }
  else if (status === "SERVICE_REQUESTED_NOT_AVAILABLE") {
    return status = "Service Requested Not Available"
  }
  else if (status === "NO_AVAILABLE_CAPACITY_CURRENTLY") {
    return status = "No Available Capacity Currently"
  }
  else if (status === "DIRECT_CLIENT_OF_VENDOR") {
    return status = "Direct Client Of Vendor"
  }
  else if (status === "VENDORS_UNWILLING_TO_BID") {
    return status = "Vendors Unwilling To Bid"
  }
  else if (status === "PARTIALLY_CREATED") {
    return status = "Partially Created"
  }
  else if (status === "OTHER") {
    return status = "Other"
  }
  else if (status === "VENDOR_EXCEEDED_TAT") {
    return status = "Vendor Exceeded TAT"
  }
  else if (status === 'YES') {
    return status = "Yes"
  }
  else if (status === 'NO') {
    return status = "No"
  }
  else if (status === 'indirect') {
    return status = "Indirect"
  }
  else if (status === 'direct') {
    return status = "Direct"
  }  
  else if (status === 'RETRIEVED') {
    return status = "Retrieved"
  }
  else if (status === 'RETRIEVAL_IN_PROGRESS') {
    return status = "Retrieval In Progress"
  }
  else if (status === 'RETRIEVAL_COMPLETED') {
    return status = "Retrieval Completed"
  }
  else if (status === 'RETRIEVAL_FAILED') {
    return status = "Retrieval Failed"
  }
  else if(status === 'POSTPONED_TO_NEXT_QUARTER') {
    return status = "Postponed To Next Quarter"
  }
  else {
    return status;
  }
}

export const getPaymentDescriptionFromPaymentTypeValue = paymentType => {
  if (paymentType === "PAYMENT_TO_CUSTOMER_PENDING") {
    return paymentType = "Payment To Customer Pending";
  }
  else if (paymentType === "PAYMENT_TO_HP_PENDING") {
    return paymentType = "Payment To HP Pending";
  }
  else if (paymentType === "SERVICE_PAYMENT_TO_DRV_PENDING") {
    return paymentType = "Service Payment To DRV Pending";
  }
  else if (paymentType === "HP Payment + HP2B") {
    return paymentType = "Hardware Payment To Customer Pending";
  }
  else if (paymentType === "HP Payment + CMO") {
    return paymentType = "Hardware Payment To Customer Completed";
  }
  else {
    return paymentType;
  }
}

export const getOrderTypeText = orderType => {
  if (orderType === "1") {
    return orderType = "Collection";
  }
  else if (orderType === "2") {
    return orderType = "Self Shipment";
  }
  else {
    return orderType;
  }
}

export const getQuoteTypeText = quoteType => {
  if (quoteType === "DRS" || !quoteType) {
    return quoteType = "NO";
  }
  else if (quoteType === "DRS_REVITALIZE") {
    return quoteType = "YES";
  }
  else {
    return quoteType;
  }
}

export const getRegionNameFromRegionCode = regionCode => {
  if (regionCode === "EMEA") return "Europe, Middle East & Africa";
  if (regionCode === "AMS" || regionCode === "NA" || regionCode === "LAR") return "Americas";
  if (regionCode === "APJ") return "Asia-Pacific-Japan";
  if (regionCode === "WW") return "World Wide";
}

export const scrollIntoGetSpecificSection = (idOfSection) => {
  const specificSectionToScroll = document.getElementById(idOfSection);
  if (specificSectionToScroll) {
    const boundingClientRect = specificSectionToScroll.getBoundingClientRect();
    boundingClientRect && window.scrollTo({
      top: boundingClientRect.top - 76,
      behavior: 'smooth'
    });
  }
}

export const setVerticalActiveMenus = (app, location, actions, dispatch) => {
  const menuList = location.pathname.split("/") || [];
  const menu = menuList.size = 2 ? menuList[1] : "";
  const subMenu = menuList.size = 2 ? menuList[2] : menuList[1];
  menu && dispatch(actions.app.setVerticalParentMenuActiveItem(menu));
  (app.activeMenuItemID !== subMenu) && dispatch(actions.app.setVerticalMenuActiveItem(subMenu));
}

export const validateEmailAddress = (email) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

export const checkIfGetAQuoteIsVisible = (countryCode) => {
  let return_value = false;
  countryOptions.forEach(region => {
    region.subOptions.forEach(country => {
      if (country.id === countryCode && country.allowedScopes.includes('indirect')) {
        return_value = true;
      }
    });
  });
  return return_value;
};

export const numberFormatter = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(2).replace(/\.0$/, '') + 'G';
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
  }
  return num.toFixed(2);
}

export const isInValidCharacterForCountryCode = (value) => {
  const splitArr = value.split(',');
  const regex = /^[A-Z][A-Z]?$/;
  let invalidCountryCode = false;

  //Avoid extra commas
  if (splitArr[splitArr.length - 1] === "" && splitArr[splitArr.length - 2] == "") {
    invalidCountryCode = true;
  }
  for (let ele in splitArr) {
    const element = splitArr[ele];
    if (!regex.test(element) && element !== "") {
      invalidCountryCode = true;
      break;
    }
    if (splitArr[ele].length > 2) {
      invalidCountryCode = true;
      break;
    }
  }

  return invalidCountryCode;
}

export const checkDuplicate = (savedContacts, requestData) => {
  let status = {};
  if (savedContacts) {
    savedContacts.forEach(contact => {
      if (requestData.firstName.toLowerCase() === contact.firstName.toLowerCase() && requestData.lastName.toLowerCase() === contact.lastName.toLowerCase() && requestData.phone === contact.phone && requestData.email.toLowerCase() === contact.email.toLowerCase()) {
        if (requestData.firstName !== contact.firstName || requestData.lastName !== contact.lastName) {
          status.isDuplicateWithDifferentCase = true;
        }
        status.isDuplicate = true;
      }
    });
  }

  return status;
}

export const filterLegalEntities = (list, legalEntityList, listType) => {
  const filteredLegalEntityList = [];
  if (listType === "countryMappingList") {
    list.forEach(mappingList => {
      if (mappingList.country) {
        legalEntityList.forEach((entity, index) => {
          if (entity.legalCountry === mappingList.country)
            filteredLegalEntityList.push(legalEntityList[index]);
        });
      }
    })
  }
  else if (listType === "selectedLegalEntity") {
    list.forEach(legalEntity => {
      if (legalEntity.legalEntityId) {
        legalEntityList.forEach((entity, index) => {
          if (entity.legalEntityId === legalEntity.legalEntityId) {
            legalEntityList[index].hpPONumber = legalEntity.hpPONumber
            filteredLegalEntityList.push(legalEntityList[index]);
          }

        });
      }
    })
  }
  return filteredLegalEntityList;
}

export const checkDirectCustomer = (profile) => {
  const directUserTypesMatrix = ["master", "regional", "legal_entity"];
  // const indirectUserTypeMatrix = ["customer", "hp_employee", "hp_partner"];
  if (directUserTypesMatrix.includes(profile.userType) && profile.customerType === "direct") {
    return true;
  }
  return false;
}
export const checkIndirectCustomer = (profile) => {
  const directUserTypesMatrix = ["customer", "hp_employee", "hp_partner"];
  // const indirectUserTypeMatrix = ["customer", "hp_employee", "hp_partner"];
  if (directUserTypesMatrix.includes(profile.userType) && profile.customerType === "indirect") {
    return true;
  }
  return false;
}
export const calculateWeekdayHours = (startDate) => {
  // Convert input dates to Date objects
  const start = new Date(startDate);
  const end = new Date();

  // Helper function to check if a date is on a weekend
  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday (0) or Saturday (6)
  }

  // Helper function to calculate the number of hours between two dates
  function hoursBetween(start, end) {
    return Math.abs(end - start) / 36e5; // Convert milliseconds to hours
  }

  // Initialize total hours
  let totalHours = 0;
  let current = new Date(start);

  // Loop through each day between start and end dates
  while (current < end) {
    const nextDay = new Date(current);
    nextDay.setDate(current.getDate() + 1);

    // Check if the current day is a weekend
    if (!isWeekend(current)) {
      // Calculate the end of the current day
      const endOfDay = new Date(current);
      endOfDay.setHours(23, 59, 59, 999);

      // Calculate hours for the current day
      const dayEnd = nextDay > end ? end : nextDay;
      totalHours += hoursBetween(current, dayEnd);
    }

    // Move to the next day
    current = nextDay;
  }

  return totalHours;
}

// Get survey ID based on environment
export const getOrderQualtricsSurveyId = () => {
  const env = process.env.NODE_ENV;
  const isProd = window.location.host.indexOf("device-recovery") === 0;
  if (env === 'development') {
    return process.env.REACT_APP_ORDER_QUALTRICS_SURVEY_ID_DEVELOPMENT;
  } else {
    if (isProd) {
      return process.env.REACT_APP_ORDER_QUALTRICS_SURVEY_ID_PRODUCTION;
    } else {
      return process.env.REACT_APP_ORDER_QUALTRICS_SURVEY_ID_DEVELOPMENT;
    }

  }
}

export const getQuoteQualtricsSurveyId = () => {
  const env = process.env.NODE_ENV;
  const isProd = window.location.host.indexOf("device-recovery") === 0;
  if (env === 'development') {
    return process.env.REACT_APP_QUOTE_QUALTRICS_SURVEY_ID_DEVELOPMENT;
  } else {
    if (isProd) {
      return process.env.REACT_APP_QUOTE_QUALTRICS_SURVEY_ID_PRODUCTION;
    } else {
      return process.env.REACT_APP_QUOTE_QUALTRICS_SURVEY_ID_DEVELOPMENT;
    }
  }
}

